export enum DownloadListType {
  DATA = 'data', // 	Data CSV download
  IAP = 'iap', // IAP CSV download
  IAPLOG = 'iaplog', // IAP Log Report download
}
